<template>
    <div class="d-flex justify-center">
        <v-card
            :width="mobile ? '90%' : '65%'"
            max-height="78vh"
            color="white"
            elevation="3"
            class="d-flex flex-column"
        >
            <v-data-table-server
                :headers="order.headers"
                :items="order.lstOrder"
                :items-per-page="order.itemsPerPage"
                no-data-text="Nenhum pedido encontrado"
                @click:row="openOrder"
                class="card-scroll"
                :page="order.page"
                :items-length="order.totalItems"
                @update:options="updateOptions"
            >
                <template v-slot:top>
                    <div :class="['px-5', mobile ? 'pb-3' : '']">
                        <v-row align="center" dense>
                            <v-col cols="12" md="9">
                                <v-text-field
                                    v-model="order.search"
                                    label="Pesquise aqui"
                                    variant="outlined"
                                    color="primary"
                                    density="compact"
                                    max-width="300px"
                                    rounded
                                    class="pt-6"
                                    @keyup.enter="search()"
                                >
                                    <template v-slot:append-inner>
                                        <v-btn
                                            icon
                                            size="small"
                                            variant="text"
                                            @click="search()"
                                        >
                                            <v-icon class="pt-1">mdi-magnify</v-icon>
                                        </v-btn>
                                    </template>
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="3" class="d-flex justify-end">
                                <v-btn
                                    color="primary"
                                    @click="openNewOrder()"
                                    rounded
                                    variant="elevated"
                                >
                                    Adicionar
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </div>
                    <v-divider></v-divider>
                </template>
                <template #headers="{ columns }">
                    <tr class="custom-header" >
                        <th v-for="column in columns" :key="column.key" style="text-align: center; font-weight: 600;">
                            {{ column.title }}
                        </th>
                    </tr>
                </template>

                <template v-slot:[`item.orderDate`]="{ item }">
                    {{ formatDateTime(item.orderDate) }}
                </template>

                <template v-slot:[`item.operation`]="{ item }">
                    {{ item.operation === OperationType.Venda ? 'Venda' : 'Compra' }}
                    <v-icon :color="item.operation === OperationType.Venda ? '#748873' : '#D73535'">
                        {{ item.operation === OperationType.Venda ? 'mdi-cart-arrow-up' : 'mdi-cart-arrow-down' }}
                    </v-icon>
                </template>
            </v-data-table-server>
        </v-card>
    </div>
    <Order/>
</template>

<script>
import { OperationType } from '@/enums/operationType';
import Order from '../Order.vue';
import { useDisplay } from 'vuetify'

export default {
    setup () {
        const { mobile } = useDisplay()
        return { mobile }
    },
    data: () => ({
        OperationType
    }),
    components: {
        Order
    },
    computed: {
        order: {
            get() {
                return this.$store.state.order
            },
        },
    },
    methods: {
        async openOrder(event, row) {
            this.$router.push({
                name: 'EditOrder',
                params: {
                    orderId: row.item.orderId
                }
            })
        },
        openNewOrder() {
            this.$router.push({ name: 'NewOrder' })
        },
        async search() {
            await this.$store.dispatch("order/search", { limit: this.order.itemsPerPage, reset: true })
        },
        formatDateTime(date) {
            if (!date) return ''

            return new Date(date).toLocaleString('pt-BR', {
                dateStyle: 'short',
                timeStyle: 'short'
            })
        },
        async updateOptions(options) {
            this.$store.commit('order/setPage', options.page)

            await this.$store.dispatch("order/search", {
                limit: options.itemsPerPage,
                page: options.page,
                reset: true
            })
        }
    },
    async mounted() {
        await this.search()
        await this.$store.dispatch('customer/findAll')
        await this.$store.dispatch('product/findAll')
        await this.$store.dispatch('stock/findAll')
        await this.$store.dispatch('seller/findAll')
        await this.$store.dispatch('payments/findAll')
    },
    watch: {
        '$store.state.order.shouldReload': {
            async handler(val) {
                if (val) {
                    await this.search()
                    this.$store.commit('order/setShouldReload', false)
                }
            }
        }
    }
}
</script>

<style>
.card-scroll {
  overflow-y: auto;
  scrollbar-width: thin;
}
</style>